import { get } from 'global/lib/lodash';
import { CourseStatus, DateRanges, EditionStatus, HighlightSectionType, HighlightTemplate, OwnershipTask, QualityType, RealmTypes, TaskContent, TaskStatus } from '../../lib/filter';

const isAnyFilterId = (id) => id == null || id === '' || id == 0 || id === '0';

// Resolve one or many ids to display names (tasks scorecard filters are multi-select arrays).
const namesForIds = (val, items, { namePath = 'name', noneLabel = 'None' } = {}) => {
  const ids = (Array.isArray(val) ? val : [val]).filter((id) => !isAnyFilterId(id));
  if (!ids.length) {
    return null;
  }
  const labels = ids.map((id) => {
    if (id === 'none') {
      return noneLabel;
    }
    const match = (items || []).find((item) => item.id == id);
    return get(match, namePath, get(match, 'defaultName', id));
  });
  return labels.join(', ');
};

const scorecardIdLabel = (val, { sState }) => namesForIds(val, get(sState, 'data.scorecards', []));
const tradeTypesLabel = (val, { sState }) => namesForIds(val, get(sState, 'data.tradeTypes', []));
const vendorIdLabel = (val, { vendors }) => {
  return get(
    get(vendors, 'data', []).find((s) => s.vendorId == val),
    'vendor.name',
    'N/A'
  );
};

export const Definitions = {
  tasks: {
    list: {
      status: TaskStatus,
      ownership: OwnershipTask,
      content: TaskContent,
      task_type_ids: () => null,
      vendor_id: vendorIdLabel,
    },
    scorecard: {
      status: TaskStatus,
      ownership: OwnershipTask,
      content: TaskContent,
      scorecard_id: scorecardIdLabel,
      trade_types: tradeTypesLabel,
      task_type_ids: () => null,
      vendor_id: vendorIdLabel,
    },
    realm: {
      includeRealm: false,
      status: TaskStatus,
      ownership: OwnershipTask,
      content: TaskContent,
      task_type_ids: () => null,
      vendor_id: vendorIdLabel,
    },
  },
  reports: {
    list: {
      realm_type: RealmTypes,
      scorecard_id: scorecardIdLabel,
      daterange: DateRanges,
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
      template_id: (val, { sState }) => {
        return get(
          get(sState, 'data.assessmentTemplates', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
    },
    data: {
      realm_type: RealmTypes,
      daterange: DateRanges,
      edition_id: (val, { sState }) => {
        return get(
          get(sState, 'data.latesteditions', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      scorecard_id: scorecardIdLabel,
      template_id: (val, { sState }) => {
        return get(
          get(sState, 'data.assessmentTemplates', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      vendor_id: (val, { vendors }) => {
        if (!val) { return '' }
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
      _showCompare: () => null,
    },
    photo: {
      realm_type: RealmTypes,
      daterange: DateRanges,
      scorecard_id: scorecardIdLabel,
      vendor_id: (val, { vendors }) => {
        return get(
          get(vendors, 'data', []).find((s) => s.vendorId == val),
          'vendor.name',
          'N/A'
        );
      },
      superset_id: (val, { supersets }) => {
        return get(
          get(supersets, 'data', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      user_id: (val, { users }) => {
        return get(
          get(users, 'data', []).find((s) => s.id == val),
          'name',
          'N/A'
        );
      },
      quality_type: QualityType,
      section_type: HighlightSectionType,
      template: HighlightTemplate,
      _photoSource: () => null,
      _includeRealm: () => null,
    },
  },
  library: {
    editions: {
      includeRealm: false,
      status: EditionStatus,
      courseStatus: CourseStatus,
      user_groups: (val) => {
        return null;
      },
    },
    courses: {
      includeRealm: false,
      status: EditionStatus,
      courseStatus: CourseStatus,
      edition_id: (val) => {
        return get(
          get(window, 'EDITIONSDATA', []).find((e) => e.id == val),
          'name',
          'N/A'
        );
      },
      role: [{ title: 'For Review', value: 'reviewer' }],
    },
  },
};
